<template>
  <div class="topic-edit">
    <el-form ref="form" :model="form" :rules="rules" label-width="100px" size="small">
      <div class="white-container">
        <el-form-item label="活动主标题" prop="name" style="width: 460px">
          <el-input v-model="form.name" placeholder="活动主标题" />
        </el-form-item>
        <el-form-item label="活动子标题" prop="subtitle" style="width: 460px">
          <el-input v-model="form.subtitle" placeholder="活动子标题" />
        </el-form-item>
        <el-form-item label="活动日期" prop="time" style="width: 460px">
          <el-date-picker v-model="form.time" type="datetimerange" placeholder="请选择活动时间" value-format="yyyy-MM-dd HH:mm:ss" />
        </el-form-item>
        <div class="flex">
          <el-form-item label="活动地址" prop="otherAddress">
            <div class="flex">
              <el-input v-model="form.otherAddress" style="width:360px" />
            </div>
          </el-form-item>
        </div>
        <el-form-item label="活动链接" prop="linkTo" style="width:460px">
          <div class="flex">
            <el-input v-model="form.linkTo" maxlength="400" show-word-limit placeholder="请填写活动链接" />
          </div>
        </el-form-item>
      </div>
      <div class="white-container marginTop">
        <el-form-item label="上传图片" prop="ActivityImageVO">
          <UploadImage :url="form.ActivityImageVO" save-path="ua_activity/uastar/" title="列表页图片" size-tips="1005px*565px" @upload="uploader" />
        </el-form-item>
        <el-form-item style="width:100%;margin-top:80px;margin-left:-50px">
          <div class="flex btns">
            <el-button type="info" @click="cancelBtn">取消</el-button>
            <el-button type="primary" @click="submit">保存</el-button>
          </div>
        </el-form-item>
      </div>
    </el-form>
    <Dialog v-if="formDialogShow" v-model="formDialogShow" :information="information" @submit-success="dialogSuccess" />
  </div>
</template>
<script>
// import { mapActions, mapState } from 'vuex'
import { ActivityTopic } from '@/model/ActivityTopic';
import UploadImage from '@/components/UploadImage';
import Dialog from '@/components/Dialog';

export default {
  components: { UploadImage, Dialog },
  data() {
    return {
      formDialogShow: false,
      information: {},
      cancelTxt: '',
      form: new ActivityTopic(),
      addressList: [],
      rules: {
        name: [
          { required: true, message: '活动主标题', trigger: 'blur' },
        ],
        ActivityImageVO: [
          { required: true, message: '请上传列表页图片', trigger: ['blur', 'change'] },
        ],
        time: [
          { type: 'array', required: true, message: '请选择活动时间', trigger: 'change' },
        ],
        uaEventCityId: [
          { required: true, message: '请选择活动城市', trigger: 'blur' },
        ],
        otherAddress: [
          { required: true, message: '请输入活动地址', trigger: 'blur' },
        ],
        // otherAddress: [
        //   { required: true, message: '请输入详细地址', trigger: 'blur' }
        // ],
        linkTo: [
          { required: true, message: '请输入活动链接', trigger: 'blur' },
        ],
      },
    };
  },
  computed: {
    cityList() {
      return this.$store.state.activity.citySelectVO;
    },
  },
  watch: {
    // 'form.uaEventCityId': {
    //   handler(val) {
    //     val && this.$Api.activity.addressOfCityById(val).then(res => {
    //       this.addressList = res;
    //       const status = this.addressList.some(item => item.id === this.form.address);
    //       if (!status) this.form.address = '';
    //       this.form.otherAddress = '';
    //     });
    //   },
    //   deep: true,
    // },
  },
  mounted() {
    const { query } = this.$route;
    if (query.id) {
      console.info('编辑');
      this.cancelTxt = '编辑';
      this.getThemActivityDetail(query.id, 'edit');
    } else if (query.copyid) {
      console.info('复制');
      this.cancelTxt = '复制';
      this.getThemActivityDetail(query.copyid, 'copy');
    } else {
      console.info('新增');
      this.cancelTxt = '新增';
    }
  },
  methods: {
    submit() {
      this.formDialogShow = true;
      this.information = {
        operation: 'submit',
        icon: 'warn',
        subTitle: "请注意活动状态，保存后已发布的活动信息将实时更新至UA HOUSE小程序",
      };
    },
    getThemActivityDetail(id, type) {
      this.$Api.activity.getThemActivityDetail(id).then(res => {
        this.form = Object.assign((['edit'].includes(type) ? {
          id: res.id,
        } : {}), {
          name: res.name,
          status: res.status,
          subtitle: res.subtitle,
          beginTime: res.beginTime,
          endTime: res.endTime,
          time: [res.beginTime, res.endTime],
          uaEventCityId: res.citySelectVO ? res.citySelectVO.id : '',
          otherAddress: res.otherAddress,
          address: res.addressSelectVO ? res.addressSelectVO.id : '',
          linkTo: res.linkTo,
          ActivityImageVO: res.converImage ? res.converImage.activityListPagePicture : '',
        });
      });
    },
    // 新增专题活动
    addEditItem() {
      const params = Object.assign(this.form);
      params.beginTime = params.time[0];
      params.endTime = params.time[1];
      params.activityImageVO = {
        activityDetailsPageHeader: '',
        activityListPagePicture: params.ActivityImageVO,
        myActivityListPictures: '',
        recommendedPcturesOfRelevantActivites: '',
      };
      delete params.time;
      !params.id && delete params.id;
      delete params.ActivityImageVO;
      this.$Api.activity.postAddThemActivity(params).then(() => {
        this.$message.success(params.id ? '编辑成功' : '保存成功');
        this.$router.go(-1);
      });
    },
    // 上传文件
    uploader(url) {
      this.form.ActivityImageVO = url;
    },
    // 取消
    cancelBtn() {
      this.formDialogShow = true;
      this.information = {
        operation: 'cancel',
        icon: 'warn',
        subTitle: `是否放弃${this.cancelTxt}，返回上级页面？`,
      };
    },
    dialogSuccess() {
      if (this.information.operation && this.information.operation === 'cancel') {
        this.$router.go(-1);
      } else if (this.information.operation && this.information.operation === 'submit') {
        this.$refs.form.validate((valid) => {
          if (valid) {
            this.addEditItem();
          } else {
            return false;
          }
        });
      }
    },
  },
};

</script>
<style lang="less" scoped>
.topic-edit {
  .el-form-item--small.el-form-item {
    margin-bottom: 30px;
  }
  .btns {
    align-items: center;
    justify-content: center;
  }
  .marginTop {
    margin-top: 30px;
  }
}
</style>
